<!-- Custom Callback  -->
<!-- <div class="cont__callback">
    <div class="snow-scene" #scene>
        <canvas class="snow-canvas" #snowCanvas></canvas>
        <div class="cont__logo_navidad">
            <img src="/assets/images/logo-callback-navidad.svg" alt="MY Posventa Renault Group">
            <div class="reno-nav">
                <img src="/assets/images/reno-corriendo.gif" alt="Navidad">
            </div>
            <div class="w-100">
                <div class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="snow-pack"></div>
    </div>
</div> -->
<!-- Normal Callback -->
<div class="cont__callback">
    <div class="cont__logo">
        <img src="/assets/images/logo-callback.svg" alt="MY Posventa Renault Group">
        <div class="w-100">
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</div>